import { useDirectMessagesTabs } from "@/react/components/shared/DirectMessages/useDirectMessagesTabs";

import { TabHeaderLegacy } from "./TabHeaderLegacy";

export const TabHeader = () => {
  const {
    dmSelectedTabIndex,
    setDmSelectedTabIndex,
    shouldShowAgentsTab,
    shouldShowMessagesTab,
    tabs,
    totalUnreadBotChatsCount,
    unreadChatRoomUuids,
    unreadChatRoomsCount,
  } = useDirectMessagesTabs();

  return (
    <TabHeaderLegacy
      dmSelectedTabIndex={dmSelectedTabIndex}
      setDmSelectedTabIndex={setDmSelectedTabIndex}
      shouldShowAgentsTab={shouldShowAgentsTab}
      shouldShowMessagesTab={shouldShowMessagesTab}
      tabs={tabs}
      totalUnreadBotChatsCount={totalUnreadBotChatsCount}
      unreadChatRoomUuids={unreadChatRoomUuids}
      unreadChatRoomsCount={unreadChatRoomsCount}
    />
  );
};
